import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";

export default function FinalExitProceed({
  finalClick,
  setFinalClick,
  propData,
  updateAPI,
  setAddOrEdit,
}) {
  console.log("popUp data to be printed here in the console", propData);
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  const updateData = async () => {
    const reqObj = {
      employee_id: propData.employeeID,
    };
    try {
      const response = await nodeinstance.put(
        `/mobilization/cancelAPIExit`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Update successfully",
          })
        );
        updateAPI();
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          finalClick ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full h-[180px] overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setFinalClick(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="mt-4 ml-4">
            <h1>Are you sure to proceed employee with final Exit</h1>
          </div>
          <button
           className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red ml-10 mt-4"
            onClick={() => {
              updateData();
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
}
